module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step4_Image3b.55bb5daa.jpg";